import React, { useState } from "react";
import "../../PregnancyAI.css";
import Header from "../components/Header";
import Footer from "../components/Footer";
import jsPDF from "jspdf";
import axios from "axios";
import configData from "../../config.json";


const questions = [
  {
    question: "Where are you in your pregnancy journey??",
    // info: "Please select your current trimester..",
    options: [
      { text: "🌱 First trimester (Weeks 1–13)", points: 0 },
      { text: "🌸 Second trimester (Weeks 14–26)", points: 0 },
      { text: "🌼 Third trimester (Weeks 27 onwards)", points: 0 },
      { text: "❓ I’m not sure​", points: 0 },
    ],
  },
  {
    question: "How far along are you (in weeks)?",
    info: "If you’re unsure, just leave it blank or approximate.",
    type: "number",
    options: [],
  },
  {
    question: "Is this your first pregnancy?",
    info: "This helps us understand your medical background better.",
    options: [
      { text: "Yes, this is my first", points: 0 },
      { text: "No, I’ve been pregnant before", points: 0 },
    ],
  },
  {
    question: "HaAre you currently consulting a gynecologist?",
    // info: "Please select your current trimester..",
    options: [
      { text: "Yes, I’m under regular care", points: 0 },
      { text: "No, not yet", points: 0 },
    ],
  },
  {
    question: "Have you experienced any of the following in the past 7 days?",
    // info: "Please select your current trimester..",
    multiSelect: true,
    options: [
      { text: "❗ Vaginal bleeding or spotting", points: 3 },
      { text: "⚠️ Lower abdominal cramps or sharp pain", points: 2 },
      { text: "😵 Dizziness or fainting spells", points: 2 },
      { text: "️ Fever above 100.4°F (38°C)", points: 2 },
      { text: "️✅ None of these​​", points: 0 },
    ],
  },
  {
    question: "Has your baby’s movement reduced or stopped in the last 24 hours?",
    // info: "Please select your current trimester..",
    options: [
      { text: "Yes, noticeably reduced", points: 3 },
      { text: "I’m not sure​", points: 1 },
      { text: "No, everything seems normal", points: 0 },
    ],
  },
    {
    question: "Are you experiencing severe headaches or any vision issues like blurriness or light flashes?",
    // info: "Please select your current trimester..",
    options: [
      { text: "Yes, frequently", points: 2 },
      { text: "Sometimes", points: 1},
      { text: "No, not at all", points: 0 },
    ],
  },
    {
    question: "Have you had swelling in your hands, feet, or face recently?",
    // info: "Please select your current trimester..",
    options: [
      { text: "Yes, I’ve noticed it", points: 2 },
      { text: "No, no swelling​", points: 0 },
    ],
  },
    {
    question: "On average, how many hours do you sleep each night?",
    // info: "Please select your current trimester..",
    options: [
      { text: "😴 Less than 5 hours", points: 2 },
      { text: "Around 5–6 hours​", points: 1 },
      { text: "7–8 hours or more", points: 0 },
    ],
  },

      {
    question: "Are you managing to eat 3 proper meals each day?",
    // info: "Please select your current trimester..",
    options: [
      { text: "Rarely — I skip or delay meals often", points: 2 },
      { text: "Sometimes — depends on the day", points: 1 },
      { text: "Yes — I eat well every day", points: 0 },
    ],
  },
        {
    question: "AHow have you been feeling emotionally in the past week?",
    // info: "Please select your current trimester..",
    options: [
      { text: "😔 Constantly anxious, irritated, or low", points: 2 },
      { text: "😕 Sometimes overwhelmed or stressed", points: 1 },
      { text: "😊 Generally calm and positive", points: 0 },
    ],
  },
          {
    question: "Are you drinking enough water daily (at least 2–3 litres)?",
    // info: "Please select your current trimester..",
    options: [
      { text: "No — I don’t drink that much", points: 2 },
      { text: "Not sure — I don’t track it", points: 1 },
      { text: "Yes — I stay well hydrated", points: 0 },
    ],
  },
            {
    question: "Do you have a history of any of the following?",
    // info: "Please select your current trimester..",
    multiSelect: true,
    options: [
      { text: "🔺 High BP or pregnancy-related hypertension", points: 2 },
      { text: "🍭 Diabetes or gestational diabetes", points: 2 },
      { text: "♀️ PCOS, thyroid, or other hormone issues", points: 1 },
      { text: "💔 Miscarriage or stillbirth in past", points: 2 },
      { text: "✅ None of the above", points: 0 } ,
    ],
  },
            {
    question: "What’s your age group?",
    // info: "Please select your current trimester..",
    options: [
      { text: "Under 20 years​", points: 2 },
      { text: "20–35 years​", points: 0 },
      { text: "36 years or older", points: 1 },
    ],
  },
];

const PregnancyRiskAssessment = () => {
  const [step, setStep] = useState(1);
  const [personalInfo, setPersonalInfo] = useState({
    name: "",
    phone: "",
    email: "",
    age: "",
    agree: false,
  });
  const [answers, setAnswers] = useState( questions.map((q) => (q.multiSelect ? [] : null)) );
  const [questionIndex, setQuestionIndex] = useState(0);
  const [showPopup, setShowPopup] = useState(false);
  const [totalScore, setTotalScore] = useState(0);
  const [pdfUrl, setPdfUrl] = useState(null);


  const handleNumberAnswer = (qIndex, value) => {
  const updatedAnswers = [...answers];
  updatedAnswers[qIndex] = Number(value);
  setAnswers(updatedAnswers);
  };

  const handleAnswer = (qIndex, optIndex) => {
    const updatedAnswers = [...answers];
    // updatedAnswers[qIndex] = points;
    updatedAnswers[qIndex] = optIndex; 
    setAnswers(updatedAnswers);
  };

  const handleNext = () => {
    if (questionIndex < questions.length - 1) {
      setQuestionIndex(questionIndex + 1);
    } else {
      handleSubmit();
    }
  };

  const handleBack = () => {
    if (questionIndex > 0) {
      setQuestionIndex(questionIndex - 1);
    }
  };

  const handleMultiAnswer = (qIndex, optIndex) => {
  const updatedAnswers = [...answers];
  const currentSelection = updatedAnswers[qIndex] || [];

  if (currentSelection.includes(optIndex)) {
    updatedAnswers[qIndex] = currentSelection.filter((i) => i !== optIndex);
  } else {
    updatedAnswers[qIndex] = [...currentSelection, optIndex];
  }

  setAnswers(updatedAnswers);
};


  const getRiskLevel = (score) => {
  if (score <= 5) {
    return {
      label: "Low Risk",
      message: "Things look good! Stay consistent with care.",
    };
  } else if (score <= 10) {
    return {
      label: "Moderate Risk",
      message:
        "Some factors need attention. Monitor symptoms and consider a teleconsult.",
    };
  } else {
    return {
      label: "High Risk",
      message:
        "Several warning signs detected. It's advised to consult your doctor immediately.",
    };
  }
};

const handleSubmit = async () => {
const score = answers.reduce((sum, selected, qIdx) => {
  const question = questions[qIdx];

  if (question.type === "number") {
    return sum;
  }

  if (question.multiSelect && Array.isArray(selected)) {
    return sum + selected.reduce((s, i) => s + (question.options[i]?.points || 0), 0);
  }

  const option = question.options?.[selected];
  return sum + (option?.points || 0);
}, 0)

  setTotalScore(score);

  // Compute risk level
  const riskData = getRiskLevel(score);

  // Build API payload
const payload = {
  name: personalInfo.name,
  phone: personalInfo.phone,
  email: personalInfo.email,
  pregnancy_stage: questions[0].options[answers[0]]?.text || "",
  pregnancy_weeks: answers[1] || null,
  first_pregnancy: questions[2].options[answers[2]]?.text || "",
  consulting_gynecologist: questions[3].options[answers[3]]?.text || "",

  // symptoms_last_7_days: questions[4].options[answers[4]]?.text || "",
  symptoms_last_7_days: Array.isArray(answers[4])
  ? answers[4].map((i) => questions[4].options[i]?.text)
  : [questions[4].options[answers[4]]?.text].filter(Boolean),

  baby_movement_change: questions[5].options[answers[5]]?.text || "",
  headaches_or_vision: questions[6].options[answers[6]]?.text || "", 
  swelling_feet_hands_face: questions[7].options[answers[7]]?.text || "", 
  average_sleep_hours: questions[8].options[answers[8]]?.text || "",
  eating_meals_regularly: questions[9].options[answers[9]]?.text || "",
  emotional_feeling_week: questions[10].options[answers[10]]?.text || "",
  drinking_enough_water: questions[11].options[answers[11]]?.text || "",

  // medical_history: questions[12].options[answers[12]]?.text || "",
    medical_history: Array.isArray(answers[12])
  ? answers[12].map((i) => questions[12].options[i]?.text)
  : [questions[12].options[answers[12]]?.text].filter(Boolean),

  age_group: questions[13].options[answers[13]]?.text || "",
  total_score: score,
  risk_level: riskData.label,
};

try {
  const response = await fetch(
    `${configData.SERVER_API_URL}/ebookuser/insert_Pregnancy_Risk_User`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    }
  );
} catch (error) {
  console.error("Error:", error);
}

  // Show result & PDF
  setShowPopup(true);
  generatePDF(score);
};



const isPersonalInfoValid =
  personalInfo.name && personalInfo.phone && personalInfo.email && personalInfo.age && personalInfo.agree;


    // PDF content
  const generatePDF = (score) => {
    const doc = new jsPDF();
  
  doc.text(`Pregnancy Risk Assessment Report`, 20, 20);
  doc.text(`Name: ${personalInfo.name}`, 20, 30);
  doc.text(`Age: ${personalInfo.age}`, 20, 40);
  // doc.text(`Gender: ${personalInfo.gender || 'N/A'}`, 20, 50);
  doc.text(`Total Risk Score: ${score}`, 20, 60);
  doc.text(`Risk Level: ${getRiskLevel(score).label}`, 20, 70);
  doc.text(getRiskLevel(score).message, 20, 80);

  const base64String = doc.output("datauristring");
  setPdfUrl(base64String); // store base64 URL in state
  setShowPopup(true);
  };

   // PDF content

    
  return (
    <>
    <Header />
    <div className="pregnancy-wrapper">
      <div className="form-container">
        
        {/* 🔧 TEST BUTTON TO TRIGGER POPUP */}
        <button onClick={() => {
          const fakeScore = 8; 
          setTotalScore(fakeScore);
          setShowPopup(true);
          generatePDF(fakeScore);
        }}>
          Show Test Popup
        </button>
  
        {step === 1 && (
          <>
            <h2 className="form-heading">Ready to Begin Your Personalized Pregnancy Diagnosis?</h2>
            <label className="form-label">Name</label>
            <input
              className="form-input"
              type="text"
              value={personalInfo.name}
              onChange={(e) =>
                setPersonalInfo({ ...personalInfo, name: e.target.value })
              }
            />

            <label className="form-label">Phone</label>
            <input
              className="form-input"
              type="number"
              value={personalInfo.phone}
              onChange={(e) =>
                setPersonalInfo({ ...personalInfo, phone: e.target.value })
              }
            />
            
            <label className="form-label">Email</label>
            <input
              className="form-input"
              type="email"
              value={personalInfo.email}
              onChange={(e) =>
                setPersonalInfo({ ...personalInfo, email: e.target.value })
              }
            />
            
            <label className="form-label">Age</label>
            <input
              className="form-input"
              type="number"
              value={personalInfo.age}
              onChange={(e) =>
                setPersonalInfo({ ...personalInfo, age: e.target.value })
              }
            />

            <p className="disclaimer">
              I acknowledge that the information provided by this tool is not a substitute for professional medical advice...
            </p>

            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={personalInfo.agree}
                onChange={(e) =>
                  setPersonalInfo({ ...personalInfo, agree: e.target.checked })
                }
              />{" "}
              By continuing, you agree to our{" "}
              <a href="#">Terms of Service</a> and <a href="#">Privacy Policy</a>
            </label>

            <button
              className="continue-button"
              disabled={!isPersonalInfoValid}
              onClick={() => setStep(2)}
            >
              Continue
            </button>
          </>
        )}

        {step === 2 && (
          <>
            <h2 className="form-heading">Pregnancy Risk Questions</h2>
           <div className="question-block">
             <p className="question-text">{questions[questionIndex].question}</p>
             {questions[questionIndex].info && (
               <p className="question-info">{questions[questionIndex].info}</p>
             )}
           
             {questions[questionIndex].type === "number" ? (
               <input
                 type="number"
                 className="form-input"
                 value={answers[questionIndex] ?? ""}
                 onChange={(e) =>
                   handleNumberAnswer(questionIndex, e.target.value)
                 }
               />
             ) : questions[questionIndex].multiSelect ? (
               questions[questionIndex].options.map((opt, idx) => (
                 <label key={idx} className="option-label">
                   <input
                     type="checkbox"
                     checked={answers[questionIndex]?.includes(idx)}
                     onChange={() => handleMultiAnswer(questionIndex, idx)}
                   />
                   {opt.text}
                 </label>
               ))
             ) : (
               questions[questionIndex].options.map((opt, idx) => (
                 <label key={idx} className="option-label">
                   <input
                     type="radio"
                     name={`q${questionIndex}`}
                     checked={answers[questionIndex] === idx}
                     onChange={() => handleAnswer(questionIndex, idx)}
                   />
                   {opt.text}
                 </label>
               ))
             )}
           </div>

            <div className="button-row">
              <button onClick={handleBack} disabled={questionIndex === 0}>
                Back
              </button>
              <button
                onClick={handleNext}
                // disabled={answers[questionIndex] === null}
                disabled={
                           questions[questionIndex].type === "number"
                             ? answers[questionIndex] === null || answers[questionIndex] === ""
                             : answers[questionIndex] === null
                         }
              >
                {questionIndex === questions.length - 1 ? "Submit" : "Next"}
              </button>
            </div>
          </>
        )}
      </div>
      

      {showPopup && pdfUrl && (
        <div className="popup-overlay">
          <div className="popup-box">
            <h3 className="popup-H3">Pregnancy Risk Assessment Report</h3>
            <h3 className="popup-H2">Got it, {personalInfo.name} Thank you for being honest and open with us 🌸</h3>
            <h2 className="popup-H2">Your total Pregnancy risk is: {totalScore}</h2>
            <h3 className="popup-H2">
              Risk Level: <span style={{ color: "#000000ff" }}>{getRiskLevel(totalScore).label}</span>
            </h3>
            <p className="popup-description">{getRiskLevel(totalScore).message}</p>
      
            <iframe
              src={pdfUrl}
              title="PDF Preview"
              width="100%"
              height="500px"
              style={{ border: "1px solid #ccc", borderRadius: "8px" }}
            />
      
            <div className="button-group">
              <a href={pdfUrl} download="Pregnancy_Risk_Report.pdf">
                <button>⬇️ Download PDF</button>
              </a>
              <button onClick={() => setShowPopup(false)} style={{ marginLeft: "1rem" }}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
    <Footer />
    </>
  );
};

export default PregnancyRiskAssessment;
